import { feedContextQuery, type FeedViewContext } from "@/features/feed/preview-context"

import type { Metadata, Route } from "next"

const FEED_CURSOR_PARAM = "cursor"
const FEED_OFFSET_PARAM = "from"

export interface FeedContinuation {
  cursor: string
  startIndex: number
}

export const feedContinuationHref = ({ cursor, startIndex }: FeedContinuation, context: FeedViewContext = {}): Route =>
  `?${new URLSearchParams({ ...feedContextQuery(context), [FEED_CURSOR_PARAM]: cursor, [FEED_OFFSET_PARAM]: String(startIndex) })}` as Route

export const parseFeedContinuation = (searchParams: Record<string, string | string[] | undefined>): FeedContinuation | undefined => {
  const cursor = searchParams[FEED_CURSOR_PARAM]
  const offset = searchParams[FEED_OFFSET_PARAM]
  if (typeof cursor !== "string" || cursor === "" || typeof offset !== "string" || !/^[1-9]\d{0,3}$/.test(offset)) return undefined
  return { cursor, startIndex: Number(offset) }
}

export const feedContinuationRobots = (continuation: FeedContinuation | undefined): Metadata["robots"] => (continuation ? { index: false, follow: true } : undefined)
